export class SpecialPaymentMethod {

    static Normal = 1;
    static HealthCareVoucher = 2;

    static Package:string = "Package";

    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}